import React from 'react';
import CheckCircleIcon from '../../../../assets/imgs/icons/check_circle.svg';
import FileType from '../../../../assets/imgs/icons/file-type.svg';
import { TString } from '../Response/Utils';
interface Props {
  file: File;
}

export function FileDownload(props: Props) {
  const downloadFile = () => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(props.file);
    fileReader.addEventListener('load', () => {
      const anchor = document.createElement('a');
      anchor.setAttribute('href', fileReader.result.toString());
      anchor.setAttribute('download', props.file.name);
      anchor.click();
    });
  };
  const extension = React.useMemo(() => props.file.name.split('.').pop(), [
    props.file.name
  ]);
  return (
    <div className="sf-fileupload-status-w">
      <div style={{ display: 'flex' }}>
        <div style={{ position: 'relative', marginRight: '12px' }}>
          <div className="file-upload-extension-icon">{extension}</div>
          <img src={FileType} alt={TString({ labelName: 'uploadFileLabel' })} />
        </div>
        <div>
          <div
            title={props.file.name}
            className="clickable"
            style={{ color: 'blue' }}
            onClick={downloadFile}
          >
            {props.file.name}
          </div>
          <div></div>
        </div>
      </div>

      <div>
        <img
          src={CheckCircleIcon}
          alt={TString({ labelName: 'fileUploadedSuccessfullyLabel' })}
        />
      </div>
    </div>
  );
}
